/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Card, Alert } from "shards-react";

import { BreadCrumbLayout } from "../../components/common/BreadCrumbLayout";

import CardHeaderUtils from "../../utils/CardHeaderUtils";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import "./create-user-password.css";
import { useParams } from "react-router-dom";
import { useMountBreadCrumb } from "../../hooks/useMountBreadCrumb";
import AdmResetPassword from "../reset-password/admin-reset-password/AdmResetPassword";

const CreateUserPassword = () => {
    const [email, setEmail] = useState("");
    const [visible, setVisible] = useState(false);
    const [alertMessage] = useState("");
    const [alertTheme] = useState("");
    const [hasAuthError] = useState(false);
    const params = useParams();

    useEffect(() => {
        const { email } = params;
        setEmail(email);
    }, []);

    const mountBreadCrumb = () => {
        return <BreadCrumbLayout textRoute="Edição de senha do usuário" />;
    };

    const closeAlert = () => {
        setVisible(false);
        hasAuthError && this.logout(history);
    };

    const menu = CardHeaderUtils.getUserMenuList("CreateUserPassword", email);

    const { setBreadCrumb } = useMountBreadCrumb();

    useEffect(() => {
        setBreadCrumb(mountBreadCrumb());
    }, []);

    return (
        <React.Fragment>
            <Card small className="mb-4">
                <CustomizedCardHeader
                    className={"border-bottom"}
                    initialName={`Edição de senha do usuário: ${email}`}
                    menuList={menu}
                    path={`/applications/user/${email}/reset_user_password`}
                    label={"Editar"}
                    showLink={true}
                />
                <Alert
                    className="mb-3 cypress--alert"
                    dismissible={closeAlert}
                    open={visible}
                    theme={alertTheme}
                >
                    {alertMessage}
                </Alert>
                <div className="form-password-redefine--container">
                    <AdmResetPassword email={email} />
                </div>
            </Card>
        </React.Fragment>
    );
};

export default CreateUserPassword;
CreateUserPassword.propTypes = {
    location: PropTypes.any,
    match: PropTypes.any,
    history: PropTypes.object
};
